module.exports = __webpack_public_path__ + "img/IMG_0867.a557e886.jpeg";